import { render, staticRenderFns } from "./AttachmentSelect.vue?vue&type=template&id=5fea382c&scoped=true"
import script from "./AttachmentSelect.vue?vue&type=script&lang=js"
export * from "./AttachmentSelect.vue?vue&type=script&lang=js"
import style0 from "./AttachmentSelect.vue?vue&type=style&index=0&id=5fea382c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fea382c",
  null
  
)

export default component.exports